import React, { Fragment, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from "@remix-run/react";
import { styled } from 'styled-components';
import { MediaSearchResultList } from './MediaSearchResultList';
import { MediaSearchTitle } from './MediaSearchTitle';
import { hasActiveFilters } from '../../../../../play-core/api/media-search/search-media';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Fonts } from '../../../../../play-core/styles/Fonts';
import { TransparentLink } from '../../../components/ClickableComponents/Link';
import { mobileHeaderHeight } from '../../../components/Header/Header.globals';
import { PlayContainer } from '../../../components/PlayContainer/PlayContainer';
import { useVideoConfig } from '../../../config/VideoAppContext';
import { SearchFilters } from '../SearchFilters/SearchFilters';
import { SearchOrder } from '../SearchOrder/SearchOrder';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const MediaResults = ({
  showAll,
  mediaResult,
  isLoading,
  showFilters,
  order,
  query,
  previousPage
}) => {
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const headingRef = useRef(null);
  const noResults = !isLoading && mediaResult && mediaResult.results.length === 0;
  const isDownloadFilterActive = query.mediaProperties?.includes('downloadAvailable') ?? false;

  // Scroll to the top of the page when the location changes and the heading
  // of the media results is currently not visible.
  useEffect(() => {
    if (headingRef.current) {
      const headingTop = headingRef.current.getBoundingClientRect().top;
      if (headingTop < mobileHeaderHeight) {
        window.scrollTo({
          top: 0
        });
      }
    }
  }, [location]);
  const {
    header: {
      audioLink
    }
  } = useVideoConfig();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(MediaSearchTitle, {
      ref: headingRef,
      mediaResult: mediaResult,
      showAll: showAll,
      isLoading: isLoading
    }), noResults ? /*#__PURE__*/_jsxs(Fragment, {
      children: [showFilters && hasActiveFilters(query) && /*#__PURE__*/_jsx(SearchFilters, {}), /*#__PURE__*/_jsxs(PlayContainer, {
        width: "small",
        children: [/*#__PURE__*/_jsx(NoResultMessage, {
          children: t('search.noResultsGoToAudio')
        }), audioLink && /*#__PURE__*/_jsx(StyledLink, {
          type: "text",
          to: audioLink.link,
          text: audioLink.title,
          showDefaultIcon: true
        })]
      })]
    }) : /*#__PURE__*/_jsxs(Fragment, {
      children: [showFilters && /*#__PURE__*/_jsx(SearchFilters, {}), /*#__PURE__*/_jsx(SearchOrder, {
        selected: query.order
      }), /*#__PURE__*/_jsx(MediaSearchResultList, {
        medias: mediaResult?.results ?? [],
        isLoading: isLoading,
        isDownloadFilterActive: isDownloadFilterActive,
        order: order,
        searchTerm: query.searchTerm,
        previousPage: previousPage
      })]
    })]
  });
};
const NoResultMessage = styled.p.withConfig({
  displayName: "MediaResults__NoResultMessage",
  componentId: "sc-1m2kskr-0"
})(["", ";color:", ";padding:32px 0;margin:0;"], Fonts.regular(14), Colors.GREY_d2d2d2);
const StyledLink = styled(TransparentLink).withConfig({
  shouldForwardProp: () => true
}).withConfig({
  displayName: "MediaResults__StyledLink",
  componentId: "sc-1m2kskr-1"
})(["width:fit-content;"]);